import React from 'react';
import { ReturnPolicy, SizeInventoryFragment } from '../../../generated/types';
import { ReturnPolicyHyperlink } from '../../ReturnPolicyInformation';
import { ReturnPolicyCopy } from '../../ReturnPolicyInformation/ReturnPolicyCopy';
import { useUser } from '../../../hooks/useUser';
import { UserStatusLevel } from '../../../constants';
import { ProductShippingEstimate } from './ProductShippingEstimate/ProductShippingEstimate';

interface Props {
  available: boolean;
  availableNow: boolean;
  shippingRestrictions: string;
  fulfilmentType: number | null;
  returnPolicy: ReturnPolicy | null;
  size: SizeInventoryFragment | null;
  variantId: string;
}

export const ProductDetailsShippingAndReturns: React.FC<Props> = ({
  size,
  available,
  returnPolicy,
  availableNow,
  fulfilmentType,
  shippingRestrictions,
  variantId
}) => {
  const { user } = useUser();

  const showDeliveryEstimate =
    available && availableNow && user.statusLevel !== UserStatusLevel.VIP;

  return (
    <ul className="ProductDetailsShippingAndReturns">
      {shippingRestrictions && <li>{shippingRestrictions}</li>}

      {showDeliveryEstimate && (
        <li>
          <ProductShippingEstimate
            size={size}
            fulfilmentType={fulfilmentType}
            variantId={variantId}
          />
        </li>
      )}

      <li>
        <ReturnPolicyCopy returnPolicy={returnPolicy} />{' '}
        <ReturnPolicyHyperlink>Learn more.</ReturnPolicyHyperlink>
      </li>
    </ul>
  );
};
